import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  makeStyles,
  Theme,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { DetailViewInformation } from './DetailViewInforamtion';
import { MediaSwiper } from './MediaSwiper';
import { MediaSwiperMobile } from './MediaSwiper/MediaSwiperMobile';
import { ChevronLeft, Close } from '@carbon/icons-react';
import { colorSet } from '@components/Provider';

interface DetailViewDialogProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  closeIcon?: React.ReactNode;
  maxWidth?: number;
}

interface DetailViewDialogStyleProps {
  maxWidth?: number;
}

const DetailViewDialog = ({
  children,
  onClose,
  isOpen,
  closeIcon,
  maxWidth
}: DetailViewDialogProps) => {
  const {
    detialViewDialog,
    detialViewDialogContent,
    detailViewDialogPaper
  } = useStyles({ maxWidth });
  const matches = useMediaQuery(useTheme().breakpoints.down(900));

  return (
    <Dialog
      className={detialViewDialog}
      open={isOpen}
      onClose={onClose}
      classes={{
        paperWidthSm: detailViewDialogPaper
      }}
    >
      {matches ? (
        <Box position={'absolute'} left={16} top={12} zIndex={3}>
          <IconButton size={'small'} onClick={onClose}>
            {closeIcon ?? <ChevronLeft size={24} color={colorSet.gray000} />}
          </IconButton>
        </Box>
      ) : (
        <Box position={'absolute'} right={16} top={8} zIndex={3}>
          <IconButton size={'small'} onClick={onClose}>
            {closeIcon ?? <Close size={24} color={colorSet.gray900} />}
          </IconButton>
        </Box>
      )}

      <DialogContent className={detialViewDialogContent}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default Object.assign(DetailViewDialog, {
  Informaiton: DetailViewInformation,
  MediaSwiper: MediaSwiper,
  MediaSwiperMobile: MediaSwiperMobile
});

const useStyles = makeStyles<Theme, DetailViewDialogStyleProps>((theme) => ({
  detialViewDialog: {},
  detailViewDialogPaper: {
    width: '100%',
    maxWidth: ({ maxWidth }) => maxWidth ?? 'unset',
    borderRadius: 16,
    [theme.breakpoints.down(900)]: {
      width: '100%',
      borderRadius: 0,
      margin: 0,
      maxHeight: () => 'unset',
      height: '100vh'
    }
  },
  detialViewDialogContent: {
    display: 'flex',
    padding: 0,
    '&:first-child': {
      padding: 0
    },
    [theme.breakpoints.down(900)]: {
      flexDirection: 'column'
    }
  }
}));
